<template>
    <div class="setting-content--section" style="padding: 0;">
        <b-tabs class="gk-tabs">
            <b-tab :title="$gettext('Costs')">
                <div style="padding: 1rem;">
                    <import-data-for
                        :typeDesc="$gettext('cost items from past periods')" type="costs" />
                </div>
            </b-tab>
            <b-tab :title="$gettext('Customers')">
                <div style="padding: 1rem;">
                    <import-data-for :typeDesc="$gettext('customer information')"
                        type="customers"
                        v-bind:note="$gettext('You can also upload the Moneybird sample file that you can download from a Moneybird account. Just select &quot;Moneybird&quot; as a source below, and ensure that the file is a CSV file.')"
                        v-bind:hasDropdown="true"
                        v-bind:sources="[{ value: 'gekko', text: $gettext('Gekko') }, { value: 'moneybird', text: $gettext('Moneybird') }]" />
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import ImportDataFor from "@/components/import_data/ImportDataFor";
// mixins
import settingsPageSetup from "@/mixins/settingsPageSetup";
export default {
    name: "ImportData",
    components: { ImportDataFor },
    mixins: [settingsPageSetup],
    data() {
        return {
            pageSettings: {
                title: this.$gettext("Import your data"),
                showCompanyPicker: true
            },
        }
    }
}
</script>
<style></style>